import React from "react";
import styled from "styled-components";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import Button from "components/Button";

const BookingButtonWrapper = styled.div`
  align-content: center;
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
  font-weight: 500;
  position: relative;
  z-index: 2;
`;

const ButtonText = styled.div`
  font-weight: 600;

  span {
    font-weight: 500;
  }
`;

const StyledButton = styled(Button)`
  font-size: 0.75rem;
  height: 1.625rem;
  margin: 0 0 0.5rem;
  transition: all 0.3s;
  width: 100%;

  :hover {
    background-color: ${({ theme }) => theme.themeColors.primary};
    color: ${({ theme }) => theme.themeColors.lightGreen3};
  }

  div {
    line-height: 1;
  }
`;

function BookingButton({ bookingType, id, isAcceptingBooking, timeSlots }) {
  const { push } = useRouter();

  const completeBookingHandler = (e) => {
    e.preventDefault();
    push({
      pathname: "/customer/booking/complete-booking/services",
      query: {
        bid: id
      }
    });
  };

  // commented out until we have the next available appts logic wired up
  // const getBookingButton = (type, isAcceptingBooking, slots) => {
  const getBookingButton = (type) => {
    if (type === "complete") {
      return (
        <BookingButtonWrapper>
          <StyledButton onClick={(e) => completeBookingHandler(e)}>
            Request appointment
          </StyledButton>
          <ButtonText>
            <span>Response time:</span> Within 24 hours
          </ButtonText>
        </BookingButtonWrapper>
      );
    }
    if (isAcceptingBooking && type === "instant") {
      return (
        <BookingButtonWrapper>
          <StyledButton outlineType="outline">Book now</StyledButton>
          {/* <ButtonText>{slots} Available appointment{slots > 1 && "s"} today</ButtonText> */}
        </BookingButtonWrapper>
      );
    }
    return <StyledButton outlineType="outline">Call to book</StyledButton>;
  };

  return getBookingButton(
    bookingType,
    id,
    isAcceptingBooking,
    timeSlots?.length
  );
}

export default BookingButton;

BookingButton.propTypes = {
  bookingType: PropTypes.string,
  id: PropTypes.string,
  isAcceptingBooking: PropTypes.bool,
  timeSlots: PropTypes.array,
};

BookingButton.defaultProps = {
  bookingType: "",
  id: "",
  isAcceptingBooking: false,
  timeSlots: [],
};
